import React from 'react'
import style from './DuoMenu.module.css'
import Newmenu from './Newmenu';

const DuoMenu = () => {
    return (
        <div className={style.menu}>
            <Newmenu />
        </div>
    )
}

export default DuoMenu
